import React from "react";
import { CheckSquare, FileText, Plane, AlertCircle } from "lucide-react";
import "./RoadmapBoard.css";

function RoadmapBoard({ tasks }) {
  const columns = [
    { id: "prep", label: "01. Preparation", icon: FileText },
    { id: "apply", label: "02. Application", icon: CheckSquare },
    { id: "move", label: "03. Relocation", icon: Plane },
  ];

  return (
    <div className="kanban-container">
      <div className="kanban-header">
        <h3>Action Plan</h3>
        <p>Your step-by-step execution guide.</p>
      </div>

      <div className="kanban-board">
        {columns.map((col) => (
          <div key={col.id} className="kanban-column">
            <div className="column-header">
              <col.icon size={16} />
              <span>{col.label}</span>
            </div>

            <div className="task-list">
              {tasks
                .filter((t) => t.stage === col.id)
                .map((task) => (
                  <div
                    key={task.id}
                    className={`kanban-card ${
                      task.is_critical ? "critical" : ""
                    }`}
                  >
                    <div className="task-header">
                      <h4>{task.title}</h4>
                      {task.is_critical && (
                        <AlertCircle size={14} className="alert-icon" />
                      )}
                    </div>
                    <p>{task.description}</p>
                    {task.doc_link && (
                      <a
                        href={task.doc_link}
                        target="_blank"
                        rel="noreferrer"
                        className="task-link"
                      >
                        Access Form →
                      </a>
                    )}
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RoadmapBoard;
